import { MutationTree } from 'vuex';
import { PostsState } from '@/store/types/posts.state';

export const mutations: MutationTree<PostsState> = {
    setEntries(state, value) {
        state.entries = value;
        state.loading = false;
    },
    setLoading(state, value) {
        state.loading = value;
    },
};
